export default __webpack_public_path__ + "static/media/img1.3d6aac87.svg";